module.exports = __webpack_public_path__ + "static/media/buy_interview_7.8cf31d65.jpg";